import { Grid, Typography, Card } from "@material-ui/core";
import { mainContentColor, modalStressTextColor } from "../lib/Color";
import { PositionType } from "../Type/TeamType";
import { BattleResultLineTeamPositionType } from "./BattleResultLine";

type Props = {
    positionType: PositionType,
    heroId: number | undefined
    result: BattleResultLineTeamPositionType
}

const BattleResultTeamMemberStatusRow = ({
    positionType,
    heroId,
    result
}: Props) => {

    const makeChangeStatusColor = (value: number) => {
        return value > 0 ? "white" : "red"
    }
    return (
        <Grid item xs={4} style={{
            textAlign: 'center',
            justifyContent: 'center',
            alignContent: 'center',
        }}>
            <Card style={{ background: mainContentColor, margin: "10px" }}>
                <div>
                    <Typography style={{ color: modalStressTextColor, margin: "10" }}>{positionType}</Typography>
                    <img
                        src={`https://www.mycryptoheroes.net/images/heroes/2000/${heroId}.png`}
                        style={{ width: 128, height: 128 }}
                    />
                </div>
                <div style={{ margin: "5" }}>
                    <Typography variant="caption" style={{ color: modalStressTextColor, margin: "10" }}>
                        {result.change_hp === 0 ? <>
                            HP: {result.hp} </> :
                            <>
                                HP: {result.hp}(<span style={{
                                    color: makeChangeStatusColor(result.change_hp)
                                }}>{result.change_hp}</span>)
                            </>}
                        {" "}
                        {result.change_phy === 0 ? <>
                            PHY: {result.phy} </> :
                            <>
                                PHY: {result.phy}(<span style={{
                                    color: makeChangeStatusColor(result.change_phy)
                                }}>{result.change_phy}</span>)
                            </>}
                        {" "}
                        {result.change_int === 0 ? <>
                            INT: {result.hp} </> :
                            <>
                                INT: {result.int}(<span style={{
                                    color: makeChangeStatusColor(result.change_int)
                                }}>{result.change_int}</span>)
                            </>}
                        {" "}
                        {result.change_agi === 0 ? <>
                            AGI: {result.agi} </> :
                            <>
                                HP: {result.agi}(<span style={{
                                    color: makeChangeStatusColor(result.change_agi)
                                }}>{result.change_agi}</span>)
                            </>}
                    </Typography>
                </div>
            </Card>
        </Grid>
    );
}

export default BattleResultTeamMemberStatusRow;